export default function assortmentTeaser () {
    const assortmentPage = $('.page--assortment')

    function selectAssortment(event) {
        const assortmentCollection = $('.assortment__teaser')
        const elem = $(event.currentTarget)
        const assortmentId = $(elem).data('iteration')
        const assortment = '#assortment__teaser--' + assortmentId
        assortmentCollection.find('a.format__plank').removeClass('active')
        assortmentCollection.find('a.format__plank').mouseover(selectCollection)
        elem.addClass('active');

        function selectCollection(event) {
            const elem = $(event.currentTarget)
            const collection = $(elem).data('collection')
            toggleBackground(collection);

            function toggleBackground(collection) {
                const $root = $(assortment + '.assortment__teaser__wrapper.active .image__box__element')
                const backgroundElem = $root.find('[data-collection="' + collection + '"]');
                $root.find('.image__box__element__item').removeClass('active');
                $root.find('.format__planks .format__plank').removeClass('active');
                backgroundElem.addClass('active');
            }
        }
    }

    function removeActiveState () {
        const assortmentCollectionWrapper = $('.assortment__teaser__wrapper')
        assortmentCollectionWrapper.removeClass('active');
    }

    function showDefaultImage () {
        const assortmentDefaultImage = $('.assortment__teaser__wrapper .image__box .image__box__element__item.default')
        const assortmentActiveImage = $('.assortment__teaser__wrapper .image__box .image__box__element__item.active')
        assortmentActiveImage.removeClass('active')
        assortmentDefaultImage.addClass('active');
    }

    assortmentPage.find('.assortment__teaser__wrapper').mouseenter(selectAssortment)
    assortmentPage.find('.assortment__teaser__wrapper').mouseleave(removeActiveState)
    assortmentPage.find('.assortment__teaser__wrapper .assortment__teaser').mouseleave(showDefaultImage)
}


// WEBPACK FOOTER //
// ./Private/Scripts/modules/teasers/assortmentTeaser.js